
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"121","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8642_2665)"}},[_c('path',{attrs:{"d":"M23 .957H.5v22.642H23V.957zM47.375.957h-22.5v22.642h22.5V.957zM71.75.957h-22.5v22.642h22.5V.957zM96.125.957h-22.5v22.642h22.5V.957zM120.5.957H98v22.642h22.5V.957z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M120.5.957h-1.91v22.642h1.91V.957z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M11.75 16.216l3.422-.873 1.43 4.434-4.852-3.561zm7.875-5.731h-6.023L11.75 4.777l-1.852 5.708H3.875l4.875 3.538-1.852 5.707 4.875-3.538 3-2.17 4.852-3.537zM36.125 16.216l3.422-.873 1.43 4.434-4.852-3.561zM44 10.485h-6.023l-1.852-5.708-1.852 5.708H28.25l4.875 3.538-1.852 5.707 4.875-3.538 3-2.17L44 10.486zM60.5 16.216l3.422-.873 1.43 4.434-4.852-3.561zm7.875-5.731h-6.023L60.5 4.777l-1.852 5.708h-6.023l4.875 3.538-1.852 5.707 4.875-3.538 3-2.17 4.852-3.537zM84.875 16.216l3.422-.873 1.43 4.434-4.852-3.561zm7.875-5.731h-6.023l-1.852-5.708-1.852 5.708H77l4.875 3.538-1.852 5.707 4.875-3.538 3-2.17 4.852-3.537zM109.25 16.216l3.422-.873 1.43 4.434-4.852-3.561zm7.875-5.731h-6.023l-1.852-5.708-1.852 5.708h-6.023l4.875 3.538-1.852 5.707 4.875-3.538 3-2.17 4.852-3.537z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8642_2665"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .957)","d":"M0 0h120v22.642H0z"}})])])])
          )
        }
      }
    